import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { LocalizationNamespaces } from 'constants/localization';

// TODO: update config
// * how to load namespaces per page without any timings
// * how to load namespaces from another storage

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en'],
    ns: LocalizationNamespaces,
    fallbackNS: LocalizationNamespaces,
    defaultNS: 'auth',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: process.env.REACT_APP_BUILD_TIME
        ? { v: process.env.REACT_APP_BUILD_TIME }
        : undefined,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged editorSaved',
    },
  });

export default i18n;
